import { Component } from 'react';
import styled from '@emotion/styled';

const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  left: 0;
  padding: 0.75em 1em;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;

  &:before {
    background-color: #FFFFFF;
    content: "";
    height: 100%;
    left: 0;
    opacity: 0.6;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;

const OCLogo = styled.a`
  background-image: url(https://d10dvh97d9q6kg.cloudfront.net/static/images/oc-logo.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  cursor: pointer;
  display: inline-block;
  height: 3.278em;
  position: relative;
  width: 3.278em;

  @media (max-width: 480px) {
    height: 3em;
    width: 3em;
  }
`;

const Title = styled.span`
  color: #56595D;
  display: inline-block;
  font-size: 1.222em;
  font-weight: 700;
  line-height: 120%;
  position: relative;

  @media (max-width: 480px) {
    font-size: 1.071em;
  }

  &:after {
    display: inline-block;
    font-size: 0.7rem;
    position: relative;
    top: -0.9em;
  }
`;

export default class TPRSHeader extends Component {
  render() {
    const {
      clickEvent,
      title
    } = this.props;

    return (
      <Header>
        <OCLogo
          onClick={clickEvent ? clickEvent.bind(this) : null}
          title="Owens Corning Total Protection Roofing System&reg;"
          data-track="learn-more"
          data-track-element-location="tprs-header"
          data-track-destination="tprs first tab"
        />
        <Title>{title}</Title>
      </Header>
    );
  }
}
